





















































































import Component from 'vue-class-component'
import appManager from '@/services/AppManager'
import { RoutePaths } from '@/router'
import { BaseVueComponent } from '@/components/BaseVueComponent'
import { Subscription as RxSubscription } from 'rxjs'
import { UserRole } from '@/core/Types'
import { UserCompanyState } from '@/services/UserCompanyManager'

interface DrawerItem {
    icon: string
    text: string
    link?: string   // use for internal routes
    href?: string   // user for external references or documents
}

@Component
export default class Portal extends BaseVueComponent {
    // user state
    userCompanyState: UserCompanyState|null = null
    userCompanyStateCounter: number = 0 // simple way to force a refresh when the state changes
    userCompanyStateSubscription: RxSubscription|undefined

    virtualUserId: string|null = null

    drawer: boolean|null = null
    drawerItemsHome: DrawerItem[] = [
        {icon: 'mdi-home', text: 'Home', link: RoutePaths.PORTAL_HOME}
    ]
    drawerItemsAdmin: DrawerItem[] = [
        {icon: 'mdi-account-clock-outline', text: 'Access Codes', link: RoutePaths.ACCESS_CODES},
        {icon: 'mdi-ticket-percent-outline', text: 'Coupons', link: RoutePaths.COUPONS},
        {icon: 'mdi-database-outline', text: 'API Events', link: RoutePaths.API_EVENTS},
        {icon: 'mdi-air-filter', text: 'Equipment', link: RoutePaths.EQUIPMENT},
    ]
    drawerItemsCompanyOwner: DrawerItem[] = [
        {icon: 'mdi-format-list-checks', text: 'Subscriptions', link: RoutePaths.SUBSCRIPTIONS},
        {icon: 'mdi-account-group-outline', text: 'Users', link: RoutePaths.USERS},
        {icon: 'mdi-key-outline', text: 'API Keys', link: RoutePaths.API_KEYS},
        {icon: 'mdi-text-box-multiple-outline', text: 'Invoices', link: RoutePaths.INVOICES},
        {icon: 'mdi-credit-card-outline', text: 'Payment Methods', link: RoutePaths.PAYMENT_METHODS},
        {icon: 'mdi-domain', text: 'Company Profile', link: RoutePaths.COMPANY_PROFILE},
    ]
    drawerItemsUser: DrawerItem[] = [
        {icon: 'mdi-account-circle-outline', text: 'My Profile', link: RoutePaths.MY_PROFILE},
        {icon: 'mdi-file-document-outline', text: 'User Manual', href: RoutePaths.DOCS_USER_MANUAL}
    ]

    // noinspection JSUnusedGlobalSymbols
    created() {
        this.userCompanyStateSubscription = appManager.userCompanyManager.stateStream.subscribe(
            state => this.onUserCompanyStateChanged(state)
        )
    }

    // noinspection JSUnusedGlobalSymbols
    destroyed() {
        if (this.userCompanyStateSubscription)
            this.userCompanyStateSubscription.unsubscribe()
    }

    getDrawerItems(): DrawerItem[] {
        const items: DrawerItem[] = []
        const userRole = this.userCompanyState?.auth?.user?.data?.role

        items.push(...this.drawerItemsHome)
        if (userRole === UserRole.ADMIN)
            items.push(...this.drawerItemsAdmin)
        if (userRole === UserRole.COMPANY_OWNER)
            items.push(...this.drawerItemsCompanyOwner)
        items.push(...this.drawerItemsUser)

        return items
    }

    isPrincipalAdmin(): boolean {
        return this.userCompanyState?.auth?.principal?.data?.role === UserRole.ADMIN
    }

    isVirtualizingUser(): boolean {
        const auth = this.userCompanyState?.auth
        const principalId = auth?.principal?.id
        const userId = auth?.user?.id

        return !!principalId && !!userId && principalId !== userId
    }

    getAppVersion(): string {
        return appManager.appVersion
    }

    getUserName(): string {
        return this.userCompanyState?.auth?.user?.data?.name || ''
    }

    getCompanyName(): string {
        return this.userCompanyState?.company?.data?.name || ''
    }

    onLogOutPressed() {
        appManager.userManager.signOut()
        this.pushRouteIfNew(RoutePaths.LANDING_HOME)
    }

    private onUserCompanyStateChanged(state: UserCompanyState) {
        this.userCompanyState = state
        this.userCompanyStateCounter += 1
    }

    private onChangeVirtualUserIdPressed() {
        appManager.userManager.setVirtualUserId(this.virtualUserId)
        this.pushRouteIfNew(RoutePaths.PORTAL_HOME)
    }
}
